import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activeMessageTemplate,
  createMessageTemplate,
  deleteMessageTemplate,
  getMessageTemplate,
  inactiveMessageTemplate,
  listMessageTemplate,
  sendMessageTemplateToMember,
  updateMessageTemplate,
} from 'api/setting/message-template/message-template.api';
import {
  ActiveMessageTemplateRequestModel,
  DeleteMessageTemplateRequestModel,
  GetMessageTemplateRequestModel,
  InactiveMessageTemplateRequestModel,
  ListMessageTemplateRequestModel,
  SaveMessageTemplateRequestModel,
  SendMessageTemplateToMemberRequestModel,
} from 'models/setting/message-template/message-template.model';

export const getMessageTemplateAction = createAsyncThunk(
  'GET_MESSAGE_TEMPLATE_REQUEST',
  async (payload: GetMessageTemplateRequestModel) =>
    getMessageTemplate(payload),
);

export const listMessageTemplateAction = createAsyncThunk(
  'LIST_MESSAGE_TEMPLATE_REQUEST',
  async (payload: ListMessageTemplateRequestModel) =>
    listMessageTemplate(payload),
);

export const createMessageTemplateAction = createAsyncThunk(
  'CREATE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: SaveMessageTemplateRequestModel, { rejectWithValue }) => {
    try {
      return await createMessageTemplate(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const updateMessageTemplateAction = createAsyncThunk(
  'UPDATE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: SaveMessageTemplateRequestModel, { rejectWithValue }) => {
    try {
      return await updateMessageTemplate(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const deleteMessageTemplateAction = createAsyncThunk(
  'DELETE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: DeleteMessageTemplateRequestModel, { rejectWithValue }) => {
    try {
      return await deleteMessageTemplate(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const inactiveMessageTemplateAction = createAsyncThunk(
  'INACTIVE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: InactiveMessageTemplateRequestModel, { rejectWithValue }) => {
    try {
      return await inactiveMessageTemplate(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const activeMessageTemplateAction = createAsyncThunk(
  'ACTIVE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: ActiveMessageTemplateRequestModel, { rejectWithValue }) => {
    try {
      return await activeMessageTemplate(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const sendMessageTemplateToMemberAction = createAsyncThunk(
  'SEND_MESSAGE_TEMPLATE_TO_MEMBER_REQUEST',
  async (
    payload: SendMessageTemplateToMemberRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await sendMessageTemplateToMember(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
